/**
 * NotFound Component (404 Page)
 * Coláiste Lurgan Management System - Professional 404 error page
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full">
        <CardContent className="text-center py-8 px-6">
          {/* 404 Number */}
          <div className="text-6xl font-bold text-muted-foreground mb-4">
            404
          </div>

          {/* Error Message */}
          <h1 className="text-2xl font-semibold mb-2">
            {t('notFound.title', 'Page Not Found')}
          </h1>

          <p className="text-muted-foreground mb-6">
            {t('notFound.message', 'The page you are looking for does not exist or you may not have permission to access it.')}
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild className="flex items-center gap-2">
              <Link to="/dashboard">
                <Home className="h-4 w-4" />
                {t('notFound.backHome', 'Back to Dashboard')}
              </Link>
            </Button>

            <Button variant="outline" onClick={() => window.history.back()} className="flex items-center gap-2">
              <ArrowLeft className="h-4 w-4" />
              {t('notFound.goBack', 'Go Back')}
            </Button>
          </div>

          {/* Coláiste Lurgan Branding */}
          <div className="mt-8 pt-6 border-t text-sm text-muted-foreground">
            {t('notFound.systemName', 'Coláiste Lurgan Management System')}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default NotFound;